// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__ASfv8","image":"Card_image__heM5R","content":"Card_content__KcQM3","row":"Card_row__gLg1v"};